import React, { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../Context/GlobalState";
import { Link } from "react-router-dom";
import { Container, Accordion, Card } from "react-bootstrap";
import { RiArrowDropDownLine } from "react-icons/ri";
import swal from "sweetalert";
import { billpunchbasicauth } from "../../utils/Credentials";
import { BASE_URL_API_TRANXT_UAT_API } from "../../utils/Constant";
const CustomSwitch = ({ checked, onChange }) => {
  return (
    <div
      onClick={() => onChange(!checked)}
      style={{
        width: "45px",
        height: "22px",
        background: checked ? "#28a745" : "#6c757d",
        borderRadius: "20px",
        position: "relative",
        cursor: "pointer",
        transition: "0.3s",
      }}
    >
      <div
        style={{
          width: "18px",
          height: "18px",
          background: "#fff",
          borderRadius: "50%",
          position: "absolute",
          top: "2px",
          left: checked ? "24px" : "2px",
          transition: "0.3s",
        }}
      />
    </div>
  );
};
const Firmdaccess = () => {
  const { user, setTransactionLoaderState } = useContext(GlobalContext);

  const [accessData, setAccessData] = useState([]);
  const Firms = JSON.parse(sessionStorage.getItem("Firms"));
  const { password, username } = billpunchbasicauth;
  const base64Credentials = btoa(`${username}:${password}`);

  const getAccessData = async () => {
    setTransactionLoaderState(true);
    try {
    
      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          firmid: Firms.pk_firmid,
          empid:user.userid
        }),
        redirect: "follow",
      };

      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetAccessManagementSuperAdmin`,
        requestOptions
      );
      const data = await response.json();
      if (data.status === "0") {
        setAccessData(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.error("Error fetching access data:", error);
      setTransactionLoaderState(false);
    }
  };

  const updateAccess = async (role_id, module_id, access) => {
    setTransactionLoaderState(true);
    try {
    
      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          firmid: Firms.pk_firmid,
          moduleid: module_id,
          role_id: role_id,
          access: access,
        }),
        redirect: "follow",
      };

      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/UpdateAccessSuperAdmin`,
        requestOptions
      );
      const data = await response.json();
      if (data.status === "0") {
        swal("Success", data.msg, "success");
        getAccessData();
      } else {
        swal("Error", data.msg, "warning");
        getAccessData();
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.error("Error updating access data:", error);
      setTransactionLoaderState(false);
    }
  };

  useEffect(() => {
    getAccessData();
  }, []);

  return (
    <>
      <div className="p-2">
        <div className="row mt-2">
          <h5 className="col">{Firms.firm_name}</h5>
          <div className="col d-flex justify-content-end">
            <Link to="/superadmin/firm-dashboard">Back</Link>
          </div>
        </div>
        <Container className="">
        <Accordion>
  {accessData.map((module, index) => (
    <Accordion.Item eventKey={index.toString()} key={index}>
      <Accordion.Header>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
          }}
        >
          <span>{module.module_name}</span>
          <RiArrowDropDownLine style={{ fontSize: "1.5rem" }} />
        </div>
      </Accordion.Header>

      <Accordion.Body
        style={{
          background: "#FEFAF6",
          border: "1px solid rgb(170, 215, 189)",
        }}
      >
        {module.data.map((role) => (
          <div
            key={role.pk_role_id}
            className="d-flex align-items-center justify-content-between mb-2"
          >
            <div style={{ fontWeight: "600", fontSize: ".8rem" }}>
              {role.role_name}
            </div>

            <CustomSwitch
              checked={role.access === "Y"}
              onChange={(checked) => {
                const newAccess = checked ? "Y" : "N";
                updateAccess(role.pk_role_id, module.module_id, newAccess);
              }}
            />
          </div>
        ))}
      </Accordion.Body>
    </Accordion.Item>
  ))}
</Accordion>
        </Container>
      </div>
    </>
  );
};

export default Firmdaccess;
